import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  ExpenseState,
  GetExpense,
  GetExpenseResponse,
  SetExpense,
} from "@/types/expense";

const initialState: ExpenseState = {
  expenses: [],
  getExpenses: [],
  expense: null,

  getExpensesResponse: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
};

export const expenseSlice = createSlice({
  name: "expenses",
  initialState,
  reducers: {
    addExpense: (state, action: PayloadAction<SetExpense>) => {
      const newExpense: SetExpense = {
        ...action.payload,
      };
      state.expenses.push(newExpense);
    },
    setExpenses: (state, action: PayloadAction<GetExpenseResponse>) => {
      state.getExpensesResponse = action.payload;
    },
    setExpense: (state, action: PayloadAction<GetExpense>) => {
      state.expense = action.payload;
    },
    updateExpense: (state, action: PayloadAction<SetExpense>) => {
      const index = state.expenses.findIndex(
        (expense) => expense.id === action.payload.id,
      );
      if (index !== -1) {
        Object.assign(state.expenses[index], action.payload);
      }
    },

    deleteExpense: (state, action: PayloadAction<number>) => {
      state.expenses = state.expenses.filter(
        (expense) => expense.id !== action.payload,
      );
    },
  },
});

export const {
  addExpense,
  setExpenses,
  setExpense,
  updateExpense,
  deleteExpense,
} = expenseSlice.actions;

export default expenseSlice.reducer;
